import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { required } from '../../../common/services/ValidationRules';
import { resetPassword, resetTokenValidate } from '../actions';
import Button from '../../../common/components/Button/Button';
import { PasswordField } from '../../../common/components/TextField/TextField';
import LoginFormWrapper from './LoginFormWrapper';

export const title = 'IoT.ON Password Reset';

function ResetPassword({ handleSubmit, isFetching }) {
  return (
    <form className="login-form" onSubmit={handleSubmit}>
      <Field
        name="newPassword"
        label="New Password"
        type="password"
        fullWidth
        disabled={isFetching}
        component={PasswordField}
        validate={[required]}
      />
      <div className="login-form-btns">
        <div className="login-btns">
          <Button type="submit" color="primary" variant="contained">
            Reset
          </Button>
        </div>
      </div>
    </form>
  );
}

const ResetPasswordForm = reduxForm({ form: 'reset-password-form', initialValues: { newPassword: '' } })(ResetPassword);

function ResetPasswordPage({ resetTokenValidate, resetPassword }) {
  const [isFetching, setIsFetching] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [linkValidated, setLinkValidated] = useState(false);
  const [invalid, setInvalid] = useState(false);
  const [token, setToken] = useState('');

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    setToken(params.get('token'));
    resetTokenValidate(params.get('token'))
      .then(() => {
        setLinkValidated(true);
        setInvalid(false);
      })
      .catch(() => {
        setLinkValidated(true);
        setInvalid(true);
      });
  }, []);

  const submitHandler = ({ newPassword }) => {
    setIsFetching(true);
    setSubmitted(true);
    resetPassword({ password: newPassword, token })
      .then(() => {
        setIsFetching(false);
        setErrorMessage('');
        setSubmitted(true);
      })
      .catch(() => {
        setIsFetching(false);
        setErrorMessage('Password reset failed');
        setSubmitted(false);
      });
  };

  return (
    <LoginFormWrapper
      isFetching={isFetching || !linkValidated}
      error={errorMessage || ''}
      backToLoginBtn={(linkValidated && invalid) || (linkValidated && !invalid && submitted)}
      title={(linkValidated && invalid) || (linkValidated && !invalid && submitted) ? title : undefined}
      text={
        linkValidated && invalid
          ? `It looks like this password reset link can't be used anymore.
            This probably means that you sent us another password reset request; in that case you'll need to use the newer reset link.`
          : linkValidated && !invalid && submitted
            ? 'Your password has been successfully changed. Click here to return to the login page.'
            : undefined
      }
    >
      {linkValidated && !invalid && !submitted && (
        <ResetPasswordForm onSubmit={submitHandler} submitted={submitted} isFetching={isFetching} />
      )}
    </LoginFormWrapper>
  );
}

ResetPasswordPage.propTypes = {
  resetTokenValidate: PropTypes.func,
  resetPassword: PropTypes.func,
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  resetPassword: (data) => dispatch(resetPassword(data)),
  resetTokenValidate: (data) => dispatch(resetTokenValidate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage);
